import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ACCOUNT_STATEMENTS } from "../../../api/queryKeys";
import { QueryAccountStatementsResponse } from "../../../types";

export const getStatementsData = (accountNum: string | undefined) =>
  api
    .get<QueryAccountStatementsResponse>(
      `v01/me/accounts/${accountNum}/statements/`
    )
    .then((res) => res.data);

export default function useGetAccountStatements(
  accountNum: string | undefined
) {
  return useQuery(
    [QUERY_ACCOUNT_STATEMENTS, accountNum],
    () => getStatementsData(accountNum),
    { enabled: !!accountNum } // only fetch if accountNum is truthy
  );
}
